import React, { useEffect, useState } from "react";
import {connect} from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import SkillInfoField from "../../../../../../Dict/Skills/Skill/components/SkillInfoDrawer/components/SkillInfoField";
import TextField  from "../../../../../../ui/TextField";
import DataSelect  from "../../../../../../ui/DataSelect";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { getFacilities } from "../../../../../../Facility/store/actions";
import { getWorldSkillsAction, getOrganizationsAction, getWsCategories, getSkillTypes } from "../../../../store/actions";
import { SmallStateIcon, StateTextColor } from "../../../../../../Dict/Skills/Skill/components/StateStyles";
import StateInfoField from "./StateInfoField";

const useStyles = makeStyles({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 32
    }
  },
  mainGrid:{
    marginTop: 8
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },

    authors: {

    },
    authors__block: {
        display: 'flex',
        justifyContent : 'space-between',
    },
    authors__input: {
        display: 'inline-block',
        width: '368px',
        marginRight: '20px'
    },
    block: {
      margin: "35px 0 15px 0"
    },
    blockrow: {
      marginTop: 16
    },
    typofield: {
      width: 140,
      minWidth: 140,
      paddingRight: 16
    },
    typovalue: {
      fontSize: 12,
    },
    svgIcon:{
      display: "inline-block",
      marginBottom: "-8px",
      marginRight: "8px"
    }
  });

const defaultData = {
    worldSkill : null,
    name : "",
    category : null,
    code : "",
    type : null,
    orgId : null
  };

const SkillEditPassport = ({
  onFormChange,
  skillData,
  skillInfo,
  getFacilities,
  facilities,
  getWorldSkills,
  getOrganizations,
  worldSkills,
  organizations,
  getWsCategories,
  categories,
  getSkillTypes,
  skillTypes
}) => {
  const classes = useStyles();
  const [data, setData] = React.useState(skillData || defaultData);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  useEffect(() => {
    //console.log(skill);
      getFacilities();
      getWorldSkills();
      getWsCategories();
      getSkillTypes();
      getOrganizations();
  }, []);

  return (
      <div className={classes.root}>
        <Typography className={classes.heading}>Общие сведения</Typography>
        <Grid container spacing={2} className={classes.mainGrid}>
          <Grid item xs={12} md={6}>
              <DataSelect
                value={data.worldSkill}
                onChange={value => onChange("worldSkill", value.id)}
                dataSource={worldSkills}
                label="На основе компетенции WorldSkills"
              />
              <DataSelect
                value={data.category}
                onChange={value => onChange("category", value.id)}
                dataSource={categories}
                label="Блок"
                required
              />
          </Grid>
          <Grid item xs={12} md={6}>
          <TextField
            value={data.name}
            onChange={e => onChange("name", e.target.value)}
            label="Наименование"
            required
          />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                    value={data.code}
                    label="Код"
                    onChange={e => onChange("code", e.target.value)}
                    required
                />
              </Grid>
              <Grid item xs={6}>
                <DataSelect
                  value={data.type}
                  onChange={value => onChange("type", value.id)}
                  label="Тип"
                  dataSource={skillTypes}
                  required
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                    readOnly
                    value={skillInfo.year}
                    label="Год"
                />
              </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
        <DataSelect
          value={data.orgId}
          onChange={value => onChange("orgId", value.id)}
          dataSource={organizations}
          label="Правообладатель"
          required
        />
        </Grid>
      </Grid>

      <div className={classes.block}>
        <div className={classes.blockrow}>
          <Typography
            className={classes.typofield}
            variant="caption"
            color="textSecondary">
            Статус компетенции:
          </Typography>
          <Typography className={classes.typovalue} variant="caption">
          {skillInfo.statusId ? <>
            {SmallStateIcon(skillInfo.statusId, classes.svgIcon)}
            <span style={{color: StateTextColor(skillInfo.statusId)}}>{skillInfo.statusName}</span>
            </> : '-'}
          </Typography>
        </div>

        <div className={classes.blockrow}>
          <StateInfoField field="Дата создания:" value={skillInfo.createDate || '-'} />
        </div>
        {(skillInfo.expertise && skillInfo.expertise.id && skillInfo.expertise.id>-1) &&
        <div className={classes.blockrow}>
          <StateInfoField field="Дата экспертизы:" value={skillInfo.expertise.statusDate || '-'} />
        </div>}
        {(skillInfo.publication && skillInfo.publication.id && skillInfo.publication.id>-1) &&
        <div className={classes.blockrow}>
          <StateInfoField field="Дата публикации:" value={skillInfo.publication.statusDate || '-'} />
        </div>}
      </div>

    { /*   <div className={classes.block}>
        <Typography className={classes.heading}>Авторы/Составители компетенции</Typography>
      </div>

          <div className={authors}>
                <div className={authors__block}>
                    <div className={authors__input}>
                        <ComboBox
                            label="Организация"
                            value={facilities.find(i => i.id === skill.data.orgId)}
                            onChange={item => change("orgId", item.id)}
                            dataSource={facilities}
                        />
                    </div>
                    <div className={authors__input}>
                            <ComboBox
                                label="Сотрудники"
                                value={skill.data.orgId || 1}
                                onChange={item => change("orgId", item.id)}
                                dataSource={facilities}
                            />
                    </div>
                </div>
            </div>*/}
      </div>
  );
};

const mapStateToProps = state => ({
    facilities : state.skillConstruct.facilities,
    worldSkills: state.skillConstruct.getWorldSkillAll,
    categories: state.skillConstruct.categories,
    skillTypes: state.skillConstruct.skillTypes,
    organizations: state.skillConstruct.getOrganizationsList
})

const mapDispatchToProps = dispatch => ({
    getFacilities: () =>  dispatch(getFacilities()),
    getWorldSkills: () => dispatch(getWorldSkillsAction()),
    getWsCategories: () => dispatch(getWsCategories()),
    getSkillTypes: () => dispatch(getSkillTypes()),
    getOrganizations: () => dispatch(getOrganizationsAction())
})


export default connect(mapStateToProps, mapDispatchToProps)(SkillEditPassport);
